





















import Vue from 'vue';
import Vuetify from 'vuetify';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'q-footer',
})
class QuantumFooter extends Vue {
    /** The version attribute in component
  */
    @Prop()
    public version?: string | number;
    /** The system name attribute in component
  */
    @Prop({
        default: () => (''),
        type: String,
    })
    public system?: string;
    /** The model name attribute in component
  */
    @Prop({
        default: () => (''),
        type: String,
    })
    public model?: string;
    /** The company name attribute in component
  */
    @Prop({
        default: () => ('Quantum'),
        type: String,
    })
    public readonly companyName?: string;
    /** The company url attribute in component
  */
    @Prop({
        default: () => ('https://www.quantum.com/'),
        type: String,
    })
    public readonly companyURL?: string;

    public getHostname(url: any) {
        const parser = document.createElement('a');

        parser.href = url;

        return parser.hostname;
    }
}
export default QuantumFooter;
